import { LoggerFactory } from 'lines-logger';

let loggerFactory = new LoggerFactory(process.env.VUE_APP_LOGGER);

export const get = ident => {
    return loggerFactory.getLogger(ident);
};
